import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ScholarshipAwardDurationDto extends EpimsBaseEntityDto {
	@IsNotEmpty() ScholarshipAwardDurationId: string;
	@IsNotEmpty() ScholarshipAwardDurationName: string;
	@IsNotEmpty() SubscriberId: string;
	ScholarshipAwardDurationVirtal_ScholarshipAwardDurationId: string;
}
